/* eslint-disable no-unneeded-ternary */
import CardWithTitle from 'components/CardWithTitle';
import CommonCollapse from 'components/common/CommonCollapse';
import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import { currencyToLocal } from 'utils/constants';

const PaymentDetails = ({
  paymentTransitions,
  tdsValue,
  tdsAmount,
  // prepayment,
  convenienceAmount,
  total,
  subtotal,
  gstValue,
  gstAmount,
  tcsValue,
  tcsAmount,
  paymentTerm,
  rateUnit,
  rate,
  quantity,
  insuranceAmount,
  isFreeTransitInsuranceIncluded,
  availInsurance,
  sellerCommissionAmount,
  buyerCommissionAmount,
}) => {
  const displayTaxableValue = subtotal;
  const displayGstAmount = gstAmount ? gstAmount : 0;
  const displayGrandTotal = total;

  return (
    <CardWithTitle title="Payment Details">
      <div className="order-status border rounded-8 p-3 position-relative pb-2 mt-2 mb-3">
        <h4 className="f-12 text-uppercase fw-medium mb-2">
          payment breakdown
        </h4>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Payment Type</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {paymentTerm ? paymentTerm : 'Not Available'}
            </span>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Taxable value</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {`${currencyToLocal(displayTaxableValue, rateUnit?.isoCurrencyCode)}`}
            </span>
          </Col>
        </Row>
        {gstAmount || gstValue ? (
          <Row className="mb-2">
            <Col sm={4}>
              <Label className="f-12 fw-medium">
                GST{gstValue && `(${gstValue}%)`}
              </Label>
            </Col>
            <Col sm={4}>
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                {`${currencyToLocal(displayGstAmount, rateUnit?.isoCurrencyCode)}`}
              </span>
            </Col>
          </Row>
        ) : (
          ''
        )}
        {tdsAmount || tdsValue ? (
          <Row className="mb-2">
            <Col sm={4}>
              <Label className="f-12 fw-medium">
                TDS{tdsValue && `(${tdsValue}%)`}
              </Label>
            </Col>
            <Col sm={4}>
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                {`${currencyToLocal(tdsAmount ? tdsAmount : 0, rateUnit?.isoCurrencyCode)}`}
              </span>
            </Col>
          </Row>
        ) : (
          ''
        )}

        {tcsValue || tcsAmount ? (
          <Row className="mb-2">
            <Col sm={4}>
              <Label className="f-12 fw-medium">
                TCS{tcsValue && `(${tcsValue}%)`}
              </Label>
            </Col>
            <Col sm={4}>
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                {`${currencyToLocal(tcsAmount ? tcsAmount : 0, rateUnit?.isoCurrencyCode)}`}
              </span>
            </Col>
          </Row>
        ) : (
          ''
        )}
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Convenience Fee</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {`${currencyToLocal(convenienceAmount ? convenienceAmount : 0, rateUnit?.isoCurrencyCode)}`}
            </span>
          </Col>
        </Row>
        {/* <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Advance Paid value</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {`${currencyToLocal(prepayment, rateUnit?.isoCurrencyCode)}`}
            </span>
          </Col>
        </Row> */}
        {availInsurance && (
          <Row className="mb-2">
            <Col sm={4}>
              <Label className="f-12 fw-medium">
                {isFreeTransitInsuranceIncluded
                  ? 'Discounted insurance amount'
                  : 'Insurance amount'}
              </Label>
            </Col>
            <Col sm={4}>
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                {`${currencyToLocal(insuranceAmount, rateUnit?.isoCurrencyCode)}`}
              </span>
            </Col>
          </Row>
        )}
        <Row className="bg-gray total-amt pt-2 mb-1">
          <Col sm={4}>
            <Label className="f-12 fw-bold">Grand Total</Label>
          </Col>
          <Col sm={4}>
            <span className="f-12 fw-bold d-block">
              {`${currencyToLocal(displayGrandTotal, rateUnit?.isoCurrencyCode)}`}
            </span>
          </Col>
        </Row>
      </div>
      {paymentTransitions &&
        paymentTransitions.map(
          ({
            // status,
            paymentMethod,
            // totalAmount,
            dueAmount,
            paidAmount,
            status,
            transactionId,
            // paymentTransactionDetails,
            id,
          }) => (
            <CommonCollapse heading="Payment" key={id}>
              <div className="order-status border rounded-8 p-3 mb-3">
                {/* <h4 className="f-12 text-uppercase fw-medium mb-2">Payment</h4> */}
                {/* <Row className="mb-2">
                  <Col sm={4}>
                    <Label className="f-12 fw-medium">Total Amount</Label>
                  </Col>
                  <Col sm={4}>
                    <span className="font-manrope text-gray f-12 fw-semibold d-block">
                      {`${currencyToLocal(totalAmount, rateUnit?.isoCurrencyCode)}`}
                    </span>
                  </Col>
                </Row> */}
                <Row className="mb-2">
                  <Col sm={4}>
                    <Label className="f-12 fw-medium">Amount Paid</Label>
                  </Col>
                  <Col sm={4}>
                    <span className="font-manrope text-gray f-12 fw-semibold d-block">
                      {`${currencyToLocal(paidAmount, rateUnit?.isoCurrencyCode)}`}
                    </span>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={4}>
                    <Label className="f-12 fw-medium">Pending Amount</Label>
                  </Col>
                  <Col sm={4}>
                    <span className="font-manrope text-gray f-12 fw-semibold d-block">
                      {`${currencyToLocal(dueAmount - paidAmount, rateUnit?.isoCurrencyCode)}`}
                    </span>
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col sm={4}>
                    <Label className="f-12 fw-medium">Payment Method</Label>
                  </Col>
                  <Col sm={4}>
                    <span className="font-manrope text-gray f-12 fw-semibold d-block">
                      {paymentMethod ? paymentMethod : 'N/A'}
                    </span>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={4}>
                    <Label className="f-12 fw-medium">Transaction Id</Label>
                  </Col>
                  <Col sm={4}>
                    <span className="font-manrope text-gray f-12 fw-semibold d-block">
                      {transactionId ? transactionId : 'N/A'}
                    </span>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={4}>
                    <Label className="f-12 fw-medium">Payment Status</Label>
                  </Col>
                  <Col sm={4}>
                    <span className="font-manrope text-gray f-12 fw-semibold d-block">
                      {status
                        ? status
                            .toLowerCase()
                            .replace('_', ' ')
                            .replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
                              letter.toUpperCase(),
                            )
                        : 'N/A'}
                    </span>
                  </Col>
                </Row>
                {/* <Row className="mb-2">
                  <Col sm={4}>
                    <Label className="f-12 fw-medium">UTR</Label>
                  </Col>
                  <Col sm={4}>
                    <span className="font-manrope text-gray f-12 fw-semibold d-block">
                      -
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <Label className="f-12 fw-medium">TDS</Label>
                  </Col>
                  <Col sm={4}>
                    <span className="font-manrope text-gray f-12 fw-semibold d-block">
                      -
                    </span>
                  </Col>
                </Row> */}
              </div>
            </CommonCollapse>
          ),
        )}
    </CardWithTitle>
  );
};

export default PaymentDetails;
